import type { UserPrivilegeFragment } from './__types__/UserPrivilegeFragment.ts';
import { getIsProductAdminFromQuery } from './getIsProductAdminFromQuery.ts';
import { getIsSiteAdminFromQuery } from './getIsSiteAdminFromQuery.ts';
import { UserPrivilege } from './UserPrivilege.ts';

export function getUserPrivilegeFromQuery(
	queryData: UserPrivilegeFragment | undefined,
): UserPrivilege | undefined {
	const isSiteAdmin = getIsSiteAdminFromQuery(queryData);
	const isProductAdmin = getIsProductAdminFromQuery(queryData);

	return typeof queryData === 'undefined'
		? undefined
		: isSiteAdmin
			? UserPrivilege.SITE_ADMIN
			: isProductAdmin
				? UserPrivilege.PRODUCT_ADMIN
				: UserPrivilege.NON_ADMIN;
}
